import { Send } from 'lucide-react';
import { APP_META, STORE_URLS } from '../config';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-white/5 bg-brand-panel/60 py-12">
      <div className="container-page flex flex-col items-center gap-6 text-center sm:flex-row sm:justify-between sm:text-left">
        <div className="flex items-center gap-3">
          <img src="/favicon.png" alt="" className="h-7 w-7" />
          <div>
            <p className="font-display text-base font-bold text-white">
              {APP_META.name}
            </p>
            <p className="text-xs text-slate-500">
              v{APP_META.version} · Designed & developed by{' '}
              <span className="text-slate-300">{APP_META.designedBy}</span>
            </p>
          </div>
        </div>

        <div className="flex items-center gap-6">
          <a
            href={STORE_URLS.telegram}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-slate-300 hover:text-brand-cyan transition-colors"
          >
            <Send className="h-4 w-4" />
            @dinarpulse
          </a>
          <a
            href="mailto:hello@dinarpulse.app"
            className="text-sm font-medium text-slate-300 hover:text-brand-cyan transition-colors"
          >
            hello@dinarpulse.app
          </a>
        </div>

        <p className="text-xs text-slate-500">© {year} Dinar Pulse</p>
      </div>
    </footer>
  );
}
